module.exports = __webpack_public_path__ + "static/media/Style11.16f38f84.PNG";